// Runs localStorage.getItem inside of a try catch
// solve issues when users disabled 3rd party cookies/localStorage
export const getLocalStorageItem = (item: string): string | null => {
  try {
    return window.localStorage.getItem(item);
  } catch {
    return null;
  }
};

// Runs localStorage.setItem inside of a try catch
// solve issues when users disabled 3rd party cookies/localStorage
export const setLocalStorageItem = (
  item: string,
  value: string
): void | null => {
  try {
    return window.localStorage.setItem(item, value);
  } catch {
    return null;
  }
};
